import { Month } from "../models/month";

export const Months: Month[] = [
    {
        name: 'January',
        number: 1
    },
    {
        name: 'February',
        number: 2
    },
    {
        name: 'March',
        number: 3
    },
    {
        name: 'April',
        number: 4
    },
    {
        name: 'May',
        number: 5
    },
    {
        name: 'June',
        number: 6
    },
    {
        name: 'July',
        number: 7
    },
    {
        name: 'August',
        number: 8
    },
    {
        name: 'September',
        number: 9
    },
    {
        name: 'October',
        number: 10
    },
    {
        name: 'November',
        number: 11
    },
    {
        name: 'December',
        number: 12
    },
];

export const MonthNames: { [key: number]: string } = {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December'
};

export const GridMonthNames: string[] = [
    "", "Jan", "Feb", "Mar", "April", "May", "June",
    "July", "Aug", "Sep", "Oct", "Nov", "Dec"
];
